import { Router } from '@angular/router';
import { Component, OnInit, inject } from '@angular/core';
import { AppConfigService, TokenService } from '@cudirect/shared-ui-library';
import { UserService } from '@workflow/ecp-shared/service/user/user.service';
import { StorageService } from '@workflow/service/storage/storage.service';
import { AuthType, NoAppsLoginType } from '@shared/enum';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'cu-dx-logout',
  template: ``,
  standalone: true,
  imports: [CommonModule]
})
export class DXLogoutComponent implements OnInit {
  // Use inject pattern instead of constructor injection
  private readonly router = inject(Router);
  private readonly tokenService = inject(TokenService);
  private readonly configService = inject(AppConfigService);
  private readonly userService = inject(UserService);
  private readonly storageService = inject(StorageService);

  /** Variable to hold auth type: phone or email */
  private authType: string;

  ngOnInit(): void {
    const userLoginType = this.userService.userLoginType;
    this.authType = userLoginType === NoAppsLoginType.EmailAddress ? AuthType.Phone : AuthType.Email;
    if (this.userService.user) {
      this.userService.logout();
      this.storageService.clear();
    }
    this.tokenService.clearCachedToken();
    this.router.navigate(['/user/login'], {
      queryParams: {
        authType: this.authType
      }
    });
  }
}
